<template>
  <div class="partners">
    <sc-placeholder name="jss-partners" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Partners',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.partners {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;

  // Child Elements
  &:deep() {
    .partners-item {
      width: calc((100% / 2) - 2rem);
      margin-right: 2rem;
      text-align: center;
      align-self: center;
      margin-bottom: 4rem;

      @include tablet-up {
        width: calc((100% / 3) - 3rem);
        margin-right: 3rem;
      }

      a {
        display: inline-block;
      }

      @include phone-only {
        &:nth-child(2n + 2) {
          margin-right: 0;
        }
      }

      @include tablet-up {
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
      }

      img {
        max-width: 100%;
        max-height: 20rem;
        height: auto;
      }
    }
  }
}
</style>
